











































































import Vue from "vue";

// Import Components
import Button from "../../elements/button/Button.vue";
import Link from "../../elements/objects/Link.vue";

export default Vue.extend({
  name: "TeaserImage",
  props: {
    imageSize: {
      type: String,
      required: false,
    },
    imagePosition: {
      type: String,
      required: false,
    },
    size: {
      type: String,
      required: false,
    },
    backgroundColor: {
      type: String,
      required: false,
    },
    headline: {
      type: String,
      required: true,
    },
    badgeColor: {
      type: String,
      required: false,
    },
    inverted: {
      type: Boolean,
      required: false,
    },
    preline: {
      type: String,
      required: false,
    },
    copy: {
      type: String,
      required: false,
    },
    badge: {
      type: String,
      required: false,
    },
    buttonClickFunction: {
      type: Function,
      required: false,
    },
    buttonText: {
      type: String,
      required: false,
    },
    linkClickFunction: {
      type: Function,
      required: false,
    },
    linkText: {
      type: String,
      required: false,
    },
    imageUrl: {
      type: String,
      required: true,
    },
  },
  inject: {
    components: {
      default: {
        Button,
        Link,
      },
    },
  },
});
